import React, { Component } from "react"
import Gallery from "../../components/Gallery/Gallery"
import { addGallery, deleteGallery, getGallery, putGallery } from "../../actions/webinars"
import { connect } from "react-redux"

class GalleryContainer extends Component {
    constructor(props) {
        super(props)
        this.inputRoot = null
        this.inputRootRef = el => {
            this.inputRoot = el
        }
        this.state = {
            deleteId: null
        }
    }

    handleDragOver(e) {
        e.preventDefault()
        if(!this.inputRoot.classList.value.includes('active')) {
            this.inputRoot.classList.add('active')
        }
    }

    handleDragLeave(e) {
        e.preventDefault()
        if(this.inputRoot.classList.value.includes('active')) {
            this.inputRoot.classList.remove('active')
        }
    }

    handleWindowDrop(e) {
        e.preventDefault()
        this.inputRoot.classList.remove('active')
    }

    handleDrop(e) {
        for(let i in e.dataTransfer.files) {
            const item = e.dataTransfer.files[i]
            if(item.type && item.type.split('/')[0] === 'image') this.props.addGallery(item)
            else if(item.type) alert('Only image is allowed')
        }
        // if(e.dataTransfer.files[0].type.split('/')[0] === 'image') addGallery(e.dataTransfer.files[0])
    }

    componentDidMount() {
        const handleDragOver = this.handleDragOver.bind(this)
        const handleDragLeave = this.handleDragLeave.bind(this)
        const handleWindowDrop = this.handleWindowDrop.bind(this)
        const handleDrop = this.handleDrop.bind(this)
        this.props.getGallery()
        window.addEventListener('dragover', handleDragOver, false)
        window.addEventListener('dragleave', handleDragLeave, false)
        window.addEventListener('drop', handleWindowDrop, false)
        this.inputRoot.addEventListener('drop', handleDrop, false)
    }

    componentWillUnmount() {
        const handleDragOver = this.handleDragOver.bind(this)
        const handleDragLeave = this.handleDragLeave.bind(this)
        const handleWindowDrop = this.handleWindowDrop.bind(this)
        const handleDrop = this.handleDrop.bind(this)
        window.removeEventListener('dragover', handleDragOver)
        window.removeEventListener('dragleave', handleDragLeave)
        window.removeEventListener('drop', handleWindowDrop)
        this.inputRoot.removeEventListener('drop', handleDrop)
    }

    onChange(e) {
        e.preventDefault()
        for(let i in e.target.files) {
            const item = e.target.files[i]
            if(item.type) this.props.addGallery(item)
        }
        e.target.value === ''
    }

    handleDelete = (id) => {
        this.setState({
            deleteId: id
        })
    }

    closeDelete = () => {
        this.setState({
            deleteId: null
        })
    }

    submitDelete = () => {
        if(this.state.deleteId) this.props.deleteGallery(this.state.deleteId)
        this.setState({
            deleteId: null
        })
    }

    render() {
        return (
            <Gallery
                isGalleryLoading={this.props.isGalleryLoading}
                showDelete={this.state.deleteId !== null}
                submitDelete={this.submitDelete}
                closeDelete={this.closeDelete}
                handleDelete={this.handleDelete}
                makeDefaultGallery={this.props.makeDefaultGallery}
                gallery={this.props.gallery}
                onChange={this.onChange.bind(this)}
                inputRootRef={this.inputRootRef}
            />
        )
    }
}



const mapStateToProps = state => ({
    gallery: state.webinars.gallery,
    isGalleryLoading: state.webinars.isGalleryLoading
})
const mapDispatchToProps = dispatch => ({
    getGallery: meta => dispatch(getGallery(meta)),
    addGallery: image => dispatch(addGallery(image)),
    deleteGallery: id => dispatch(deleteGallery(id)),
    makeDefaultGallery: id => dispatch(putGallery(id, { is_default: true }))
})

export default connect(mapStateToProps, mapDispatchToProps)(GalleryContainer)


// WEBPACK FOOTER //
// ./src/containers/Gallery/Gallery.js